'use client';

import { ListFilter, X } from 'lucide-react';

import { Button } from '@/components/ui/Button';

interface FilterSummaryProps {
  /** Total number of results returned by the current filters */
  totalResults: number;
  /** Callback triggered when the user wishes to clear every filter */
  onClearAll: () => void;
  /** Singular label used when exactly one result is returned */
  nounSingular?: string;
  /** Plural label used when zero or many results are returned */
  nounPlural?: string;
}

/**
 * Displays a concise summary of active filters together with the number of
 * items returned and an affordance to clear every active filter.
 */
export function FilterSummary({
  totalResults,
  onClearAll,
  nounSingular = 'result',
  nounPlural = 'results',
}: FilterSummaryProps) {
  const label = totalResults === 1 ? nounSingular : nounPlural;

  return (
    <div className="flex items-center justify-between gap-4 p-3 bg-muted/50 border border-border/40 rounded-sm">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <ListFilter className="h-4 w-4" />
        <span>
          {totalResults} {label} found
        </span>
      </div>
      <Button variant="ghost" size="sm" onClick={onClearAll} className="gap-2">
        <X className="h-4 w-4" />
        Clear all
      </Button>
    </div>
  );
}


